// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__vvxhU {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Modal_modalContent__8fAru {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 90%;
  width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.Modal_modalHeader__Jf\\+61 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 10px;
}

.Modal_titleContainer__aLfBh {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.Modal_title__yAh0h {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

.Modal_editIcon__7oY\\+F {
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
}
.Modal_editIcon__7oY\\+F:hover {
  opacity: 1;
}

.Modal_titleInput__em\\+Je {
  flex: 1 1;
  min-width: 0;
  padding: 6px 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
  resize: vertical;
  min-height: 36px;
  line-height: 1.4;
}
.Modal_titleInput__em\\+Je:focus {
  border-color: #1565c0;
  box-shadow: 0 0 0 2px rgba(21, 101, 192, 0.1);
}

.Modal_confirmButton__\\+dd2- {
  padding: 6px 12px;
  background: #1565c0;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}
.Modal_confirmButton__\\+dd2-:hover {
  background: #1976d2;
}
.Modal_confirmButton__\\+dd2-:active {
  transform: translateY(1px);
}

.Modal_closeButton__Szj\\+m {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: #666;
  font-size: 20px;
  line-height: 1;
  transition: color 0.2s ease;
  flex-shrink: 0;
}
.Modal_closeButton__Szj\\+m:hover {
  color: #333;
}

.Modal_modalBody__2Yp\\+V {
  color: #2c3e50;
  line-height: 1.6;
  white-space: pre-wrap;
}

@media (max-width: 768px) {
  .Modal_modalContent__8fAru {
    width: calc(100% - 32px);
    padding: 16px;
  }
  .Modal_modalHeader__Jf\\+61 {
    margin-bottom: 16px;
  }
  .Modal_title__yAh0h {
    font-size: 16px;
  }
  .Modal_editIcon__7oY\\+F {
    width: 18px;
    height: 18px;
  }
  .Modal_titleInput__em\\+Je {
    font-size: 14px;
    padding: 4px 8px;
  }
  .Modal_confirmButton__\\+dd2- {
    padding: 4px 10px;
    font-size: 13px;
  }
  .Modal_closeButton__Szj\\+m {
    padding: 6px;
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/index.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAAF;AAEE;EACE,qBAAA;EACA,6CAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,0BAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,cAAA;AAHF;AAKE;EACE,WAAA;AAHJ;;AAOA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAJF;;AAOA;EACE;IACE,wBAAA;IACA,aAAA;EAJF;EAOA;IACE,mBAAA;EALF;EAQA;IACE,eAAA;EANF;EASA;IACE,WAAA;IACA,YAAA;EAPF;EAUA;IACE,eAAA;IACA,gBAAA;EARF;EAWA;IACE,iBAAA;IACA,eAAA;EATF;EAYA;IACE,YAAA;IACA,eAAA;EAVF;AACF","sourcesContent":[".modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  max-width: 90%;\n  width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 10px;\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n  flex: 1;\n  min-width: 0;\n  word-wrap: break-word;\n  white-space: normal;\n  line-height: 1.4;\n}\n\n.editIcon {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n  flex-shrink: 0;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.titleInput {\n  flex: 1;\n  min-width: 0;\n  padding: 6px 10px;\n  font-size: 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  outline: none;\n  resize: vertical;\n  min-height: 36px;\n  line-height: 1.4;\n  \n  &:focus {\n    border-color: #1565c0;\n    box-shadow: 0 0 0 2px rgba(21, 101, 192, 0.1);\n  }\n}\n\n.confirmButton {\n  padding: 6px 12px;\n  background: #1565c0;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  \n  &:hover {\n    background: #1976d2;\n  }\n  \n  &:active {\n    transform: translateY(1px);\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: #666;\n  font-size: 20px;\n  line-height: 1;\n  transition: color 0.2s ease;\n  flex-shrink: 0;\n  \n  &:hover {\n    color: #333;\n  }\n}\n\n.modalBody {\n  color: #2c3e50;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 768px) {\n  .modalContent {\n    width: calc(100% - 32px);\n    padding: 16px;\n  }\n\n  .modalHeader {\n    margin-bottom: 16px;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .editIcon {\n    width: 18px;\n    height: 18px;\n  }\n\n  .titleInput {\n    font-size: 14px;\n    padding: 4px 8px;\n  }\n\n  .confirmButton {\n    padding: 4px 10px;\n    font-size: 13px;\n  }\n\n  .closeButton {\n    padding: 6px;\n    font-size: 18px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__vvxhU`,
	"modalContent": `Modal_modalContent__8fAru`,
	"modalHeader": `Modal_modalHeader__Jf+61`,
	"titleContainer": `Modal_titleContainer__aLfBh`,
	"title": `Modal_title__yAh0h`,
	"editIcon": `Modal_editIcon__7oY+F`,
	"titleInput": `Modal_titleInput__em+Je`,
	"confirmButton": `Modal_confirmButton__+dd2-`,
	"closeButton": `Modal_closeButton__Szj+m`,
	"modalBody": `Modal_modalBody__2Yp+V`
};
export default ___CSS_LOADER_EXPORT___;
